import { onlineManager } from "@tanstack/react-query";

export const GRAZING_OFFLINE_REPLAY_LOG_TAG = "grazing-offline-replay";

export function logGrazingOfflineReplay(
  phase: string,
  payload: Record<string, unknown> = {}
): void {
  console.log(GRAZING_OFFLINE_REPLAY_LOG_TAG, {
    phase,
    online: onlineManager.isOnline(),
    replayLoggedAt: new Date().toISOString(),
    ...payload,
  });
}

export function replayErrorPayload(error: unknown): Record<string, unknown> {
  if (error instanceof Error) {
    return {
      errorName: error.name,
      errorMessage: error.message,
    };
  }
  return { error };
}
